export default {
    upload: 'Upload file',
    fileName: 'File name',
    size: 'Size',
    noFiles: 'No files yet',
    noFilesText: 'Files you upload for this client will show up here.',
    noResults: 'No files found',
    space: 'Disk space of your account',
    app: 'Mobile app',
    share: "Share to the client's app",
    sharedSuccess: "File shared to the client's app",
    unsharedSuccess: 'File no longer shared',
    fromClient: 'Sent by the client from the app',
    clientUploads: 'Client uploads',
    clientUploadsHint: 'The client can send you photos and PDFs from the app',
    clientUploadsOffGlobally: 'Turned off for all clients in your settings.',
    openSettings: 'Open settings',
    clientUploadsOn: 'The client can now send you files',
    clientUploadsOff: 'The client can no longer send you files',
    fileTooBig: 'The file is over the 10MB limit',
    dropzone: 'Drop a file or click here to select (Max size: 10MB)'
}